import React, { FC, KeyboardEvent } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Form as FormikForm } from 'formik';

import { useGroupData } from 'hooks';
import { Loaders } from 'components';

import EditActions from '../Edit/EditActions';
import { GroupDetails, GroupManagers, GroupSettings, GroupSources } from './index';
import CreateActions from '../New/CreateActions';

interface IProps {
  action: 'edit' | 'create';
  isWorking: boolean;
}

const GroupForm: FC<IProps> = ({ action, isWorking }) => {
  const { t } = useTranslation();
  const { isLoading } = useGroupData();

  function handleKeyDown(event: KeyboardEvent<HTMLFormElement>) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  if (isLoading) {
    return <Loaders.Standard />;
  }

  return (
    <FormikForm onKeyDown={handleKeyDown}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography color="inherit" variant="h4">
            {action === 'edit' ? t('groups:editGroup') : t('groups:createGroup')}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <GroupDetails />
        </Grid>

        <Grid item xs={12}>
          <GroupSettings />
        </Grid>

        {action === 'edit' && (
          <Grid item xs={12}>
            <GroupManagers />
          </Grid>
        )}

        {action === 'edit' && (
          <Grid item xs={12}>
            <GroupSources />
          </Grid>
        )}

        <Grid item xs={12}>
          {action === 'edit' ? (
            <EditActions isWorking={isWorking} />
          ) : (
            <CreateActions isWorking={isWorking} />
          )}
        </Grid>
      </Grid>
    </FormikForm>
  );
};

export default GroupForm;
